var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.121,
    height: 95.479,
    viewBox: "0 0 95.121 95.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61791",
    "data-name": "Group 61791",
    transform: "translate(-949.235 -869.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(949.235 884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159029",
    "data-name": "Path 159029",
    d: "M61.063,33.808a7.356,7.356,0,0,0-10.372,0L33.808,50.69l-9.526-9.526a7.356,7.356,0,0,0-10.372,0L1,54.074V19.39A18.39,18.39,0,0,1,19.39,1H63.527a18.39,18.39,0,0,1,18.39,18.39V54.663ZM23.068,19.39a5.517,5.517,0,1,0,5.517,5.517A5.517,5.517,0,0,0,23.068,19.39ZM1,64.373A18.39,18.39,0,0,0,19.39,81.917H63.527a18.39,18.39,0,0,0,18.39-16.993L56.171,39.178,39.289,56.06a7.356,7.356,0,0,1-10.372,0L19.39,46.534Z",
    transform: "translate(-1 -1)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61790",
    "data-name": "Group 61790",
    transform: "translate(-4253.553 966.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221159",
    "data-name": "Path 221159",
    d: "M66.81,48a18.81,18.81,0,1,0,18.81,18.81A18.807,18.807,0,0,0,66.81,48Z",
    transform: "translate(5211.288 -144)",
    fill: "#b5b5b5",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221162",
    "data-name": "Path 221162",
    d: "M19.824,5.259a.916.916,0,0,1,.019,1.3L9.765,16.938a.916.916,0,0,1-1.324-.009l-5.192-5.5a.916.916,0,1,1,1.332-1.258l4.535,4.8,9.411-9.7A.916.916,0,0,1,19.824,5.259Z",
    transform: "translate(5266.288 -88)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptEmpty);
export default __webpack_public_path__ + "static/media/acceptEmpty.84046e6141385afe6ba3260f955d51da.svg";
export { ForwardRef as ReactComponent };